import symbolIsSPX from './symbolIsSPX';
import { TradierSymbolParser } from '../tradier-symbol/TradierSymbolParser';

class SymbolParser {
  constructor(public symbol: string, public maintainSPXW?: boolean) {}

  public get parsed() {
    return new TradierSymbolParser(this.symbol).parsed;
  }

  public get type() {
    return this.parsed?.optionType;
  }

  public get strike() {
    return this.parsed?.strike;
  }

  public get expiration() {
    return this.parsed?.expiration;
  }

  public get underlyingSymbol() {
    if (this.symbol.length < 7) {
      return this.symbol;
    }

    return this.parsed?.underlyingSymbol;
  }

  public get isSPX() {
    return symbolIsSPX(this.underlyingSymbol);
  }
}

export default SymbolParser;
